var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-error-page"},[_c('h1',{staticClass:"mb-30"},[_vm._v(" "+_vm._s(_vm.$t("page_not_found.text"))+" ")]),_c('DgButton',{attrs:{"href":"/redirect"}},[_vm._v(" "+_vm._s(_vm.$t("page_not_found.button"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }